import React from 'react';
import { Box, Flex, List, ListItem, Text } from '@chakra-ui/react';
import { ImpactUpsellIcon } from '../icons/ImpactUpsellIcon';

const ModalContentSection = ({
  title,
  bullets,
  icon: Icon,
  sectionReference,
}: {
  title?: string;
  bullets: { title: string; body?: string }[];
  icon: ImpactUpsellIcon;
  sectionReference: string;
}) => (
  <Box mt={7}>
    {title && <Text fontWeight="semibold">{title}</Text>}

    <List spacing={4} mt={3}>
      {bullets.map((bullet, index) => (
        <ListItem key={`${sectionReference}-${index}`}>
          <Flex alignItems="center">
            <Icon colour="#1F2C46" withBackground="#8097C3" />

            <Box>
              <Text fontWeight="semibold">{bullet.title}</Text>

              {bullet.body && (
                <Text fontSize="sm" fontWeight="normal">
                  {bullet.body}
                </Text>
              )}
            </Box>
          </Flex>
        </ListItem>
      ))}
    </List>
  </Box>
);

export default ModalContentSection;
